import { PATHS } from "../../../packs/travel_book/avia_v3/utils/variables/api"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${PATHS.ADMIN.BASE}${PATHS.ADMIN.DEPARTMENTS}/${endpoint ? endpoint : ""}`

export const departamentsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDepartaments: builder.query({
      query: () => ({
        url: buildBundleUrl(""),
        method: "GET",
      }),
    }),
  }),
})

export const { useGetDepartamentsQuery, useLazyGetDepartamentsQuery } = departamentsService
